// Versión del motor del agente esperada por este frontend.
// Actualizar cada vez que se modifique código Python del agente.
export const LATEST_ENGINE_VERSION = '2026-03-28.2';

/**
 * Compara la versión del agente con la esperada.
 * Retorna true si el agente necesita actualización.
 *
 * Si el agente no reporta versión (undefined o 'unknown'), es un agente
 * anterior al sistema de versionamiento — definitivamente desactualizado.
 */
export function isAgentOutdated(agentEngineVersion: string | undefined): boolean {
  if (!agentEngineVersion || agentEngineVersion === 'unknown') return true;
  return agentEngineVersion !== LATEST_ENGINE_VERSION;
}
